import { render } from "./Home.vue?vue&type=template&id=63eb7a3e&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=63eb7a3e&scoped=true&lang=css"

import exportComponent from "/Users/chencheng/code/bethlehem/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63eb7a3e"]])

export default __exports__